import { apiClient } from './client'
import type { ApiResponse, AdminRole, AdminRoleRequest } from '@/types/api'

export const rolesApi = {
  getRoles: () =>
    apiClient.get<ApiResponse<AdminRole[]>>('/admin/roles'),

  getRole: (id: number) =>
    apiClient.get<ApiResponse<AdminRole>>(`/admin/roles/${id}`),

  createRole: (data: AdminRoleRequest) =>
    apiClient.post<ApiResponse<AdminRole>>('/admin/roles', data),

  updateRole: (id: number, data: AdminRoleRequest) =>
    apiClient.put<ApiResponse<AdminRole>>(`/admin/roles/${id}`, data),

  deleteRole: (id: number) =>
    apiClient.delete(`/admin/roles/${id}`),

  getPermissions: () =>
    apiClient.get<ApiResponse<string[]>>('/admin/roles/permissions'),

  assignUserRole: (userId: number, roleId: number | null) =>
    apiClient.put(`/admin/roles/users/${userId}`, { roleId }),
}
